export enum KeySide {
    up = 1 << 0,
    down = 1 << 1,
    left = 1 << 2,
    right = 1 << 3,
    stop = 1 << 4,
    block = 1 << 5
  }
  